export function base_fm() {
    jQuery(window).scroll(function (event) {
        var stop = 0;

        if (jQuery('.standard-schedule').length) {
            stop = Math.floor(jQuery('.standard-schedule').offset().top);
        }

        var windowPosition = Math.floor(jQuery(this).scrollTop());


        // whether that's below the form
        if (windowPosition >= 100) {
            jQuery('body').addClass('fixed');
        } else {
            jQuery('body').removeClass('fixed');
        }

        if (windowPosition >= stop) {
            jQuery('body').addClass('schedule-fixed');
        } else {
            jQuery('body').removeClass('schedule-fixed');
        }

    });

// you want to enable the pointer events only on click;

    jQuery('.embed-responsive iframe').addClass('noscroll'); // set the pointer events to none on doc ready
    jQuery('.embed-responsive').on('click', function () {
        jQuery('.embed-responsive iframe').removeClass('noscroll'); // set the pointer events true on click
    });

// you want to disable pointer events when the mouse leave the canvas area;

    jQuery('.embed-responsive').mouseleave(function () {
        jQuery('.embed-responsive iframe').addClass('noscroll'); // set the pointer events to none when mouse leaves the map area
    });

    jQuery('p:empty').remove();


// errors


// accordion

    jQuery('.accordion>div>div').hide();
    jQuery('.accordion h4, .accordion h3').click(function () {
        if (jQuery(this).hasClass('open')) {
            jQuery(this).removeClass('open').siblings('div').slideUp();
        } else {
            jQuery(this).addClass('open').siblings('div').slideDown();
        }
    });


// Only run on the contact page
    if (window.location.href.indexOf("/contact/") > -1) {

        // something is resetting it on load and it's not something we done. Force it to be set.
        setTimeout(function () {
            // Get the URL parameters
            var params = new URLSearchParams(window.location.search);

            // Check if the 'dept' parameter is in the URL
            if (params.has('dept')) {
                // Get the value of the 'dept' parameter
                var dept = params.get('dept');

                // Select the dropdown option that matches the 'dept' parameter
                jQuery('select[name="dept"]').val(dept);
            }
        }, 1000);
    }
}
